import { appBrandText } from './brand';

export const NATIONAL_EXAM_COPY = {
  SEAL_SCORE: '20',
  SEAL_TOTAL: '/20',
  SEAL_LABEL: 'OBJECTIF',
  HOME_KICKER: 'LES VRAIS SUJETS. TON MOMENT.',
  SUBJECT_KICKER: 'CHOISIS TON ÉPREUVE',
  RESULT_KICKER: 'COPIE RENDUE',
  BACK_HOME: '← Tous les examens',
  BACK_SUBJECTS: '← Changer de sujet',
  FLAG: 'À revoir',
  UNFLAG: 'Retirer des questions à revoir',
  ANSWER_LABEL: 'Ta réponse',
  HOME_TITLE: 'Sujets nationaux',
  HOME_INTRO: 'Entraîne-toi dans les conditions de l’épreuve, puis reçois une correction détaillée.',
  EMPTY: 'Aucun sujet relu n’est publié pour le moment.',
  LOADING: 'Chargement du sujet…',
  LOAD_ERROR: 'Ce sujet est momentanément indisponible.',
  SUBJECTS: 'Choisir un sujet',
  START: 'Passer ce sujet',
  SUBMIT: 'Rendre la copie',
  RESULT_TITLE: 'Résultat',
  COLD_RESULT: 'Aucun résultat n’est conservé dans ce lien.',
  BACK: 'Retour aux sujets',
  TIMER: (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`,
  NOTE: (note) => `${note} / 20`,
  COMPLETION: (value) => `${Math.round(value * 100)} % complété`,
  ACCURACY: (value) => `${Math.round(value * 100)} % de réussite`,
  WEAK_SKILL: (correct, total, confidence) => `${correct} / ${total} · confiance ${confidence}`,
  PDF_SUBJECT: 'Télécharger le sujet',
  PDF_CORRECTION: 'Télécharger la correction',
  TIMER_MODES: {
    officiel: 'Temps officiel',
    libre: 'Sans chronomètre',
    personnalise: 'Temps personnalisé',
  },
  EXAM_LABELS: {
    brevet: 'Brevet',
    'bac-premiere': 'Bac première',
    'bac-terminale': 'Bac terminale',
  },
  ERR_SELECTION: 'Choisissez un sujet national.',
};

/** Examination Chamber copy. Pressure comes from the clock, never from the wording. */
export const EXAM_CHAMBER_COPY = {
  BRAND_HOME: `Accueil ${appBrandText('EXAM')}`,
  DIPLOMA_NAME: { brevet: 'Brevet', 'bac-premiere': 'Bac Première', 'bac-terminale': 'Bac Terminale' },

  /* ── The gate: one button, the draw, the conditions folded away ────────── */
  GATE_LEAD: {
    brevet: 'Essaie de passer le brevet. Un vrai sujet, tiré au sort, en temps réel. Tu rends ta copie, tu as ta note et la correction.',
    'bac-premiere': 'Essaie de passer le bac de première. Un vrai sujet, tiré au sort, en temps réel. Tu rends ta copie, tu as ta note et la correction.',
    'bac-terminale': 'Essaie de passer le bac. Un vrai sujet, tiré au sort, en temps réel. Tu rends ta copie, tu as ta note et la correction.',
  },
  GATE_ENTER: 'Entrer en salle',
  GATE_FACT: (duration) => `${duration} · le chrono démarre maintenant`,
  GATE_CONFIGURE: 'Régler les conditions',
  GATE_EMBLEM: { brevet: 'BREVET', 'bac-premiere': 'BAC', 'bac-terminale': 'BAC' },
  IRREVERSIBLE: Object.freeze([
    'Le chronomètre ne s’arrête plus, même si tu fermes l’onglet.',
    'Une copie scellée ne se rouvre pas.',
  ]),
  LEAVE_WARNING: 'L’épreuve est en cours. Le chronomètre continue.',

  /* ── Convocation: the beats played while the session is created ────────── */
  CONVOCATION: {
    summons: 'CONVOCATION',
    duration: (duration) => `ÉPREUVE · ${duration}`,
    drawn: (session) => `SESSION ${session}`,
  },
  CONVOCATION_MIXED: 'SUJET MIXÉ',
  CONVOCATION_LABEL: 'Ouverture de l’épreuve',

  /* ── Candidate name: written on the rail, never a step ─────────────────── */
  CANDIDATE_RAIL: 'Nom',
  CANDIDATE_RAIL_PLACEHOLDER: 'Prénom ou pseudonyme',
  CANDIDATE_REQUIRED: 'Écris ton nom en haut de la copie pour pouvoir la sceller.',
  CANDIDATE_GO_WRITE: 'Écrire mon nom',

  SOUND: 'Son',
  SOUNDS: { off: 'Coupé', on: 'Activé' },
  RESUME_TITLE: 'Épreuve en cours',
  RESUME_ACTION: 'Reprendre',

  HOME_EYEBROW: 'SALLE D’EXAMEN · SIMULATION',
  HOME_TITLE: 'La salle est prête.',
  HOME_PUNCH: 'L’horloge aussi.',
  HOME_SUBTITLE: 'Vrais sujets, temps officiel, copie scellée. Rien ici ne te juge : seul le temps presse.',
  DOSSIER: (n) => `DOSSIER ${String(n).padStart(2, '0')}`,
  SUBJECT_COUNT: (n) => `${n} sujet${n > 1 ? 's' : ''}`,
  EXERCISE_COUNT: (n) => `${n} exercice${n > 1 ? 's' : ''}`,
  ITEM_COUNT: (n) => `${n} question${n > 1 ? 's' : ''}`,
  MIX_AVAILABLE: (exercises, chapters) => `Sujet mixé · ${exercises} exercices officiels · ${chapters} chapitres`,
  SOURCES: (hosts) => `Sources : ${hosts.join(', ')}`,
  UNAVAILABLE: 'En préparation',
  OPEN_DOSSIER: 'Ouvrir le dossier',
  NOT_OFFICIAL: 'Simulation non officielle. Aucun diplôme n’est délivré.',
  LOADING: 'Ouverture de la salle…',
  LOAD_ERROR: 'La salle est fermée pour le moment. Réessaie dans un instant.',
  EMPTY: 'Aucun sujet disponible pour le moment.',
  UNKNOWN_DIPLOMA: 'Cette épreuve n’existe pas.',
  BACK_HOME: '← Toutes les épreuves',

  CALCULATOR: {
    exam_mode: 'Calculatrice en mode examen',
    automatismes_without_then_exam_mode: 'Automatismes sans calculatrice, puis mode examen',
  },
  CONTENT_KIND: {
    official_verbatim: 'Sujet officiel',
    official_adapted: 'Sujet officiel adapté',
  },
  MODES: {
    full: 'Sujet complet',
    simulation_30: 'Simulation 30 min',
    chapter_review: 'Réviser un chapitre',
  },
  MODE_HINTS: {
    full: (duration) => `Le sujet entier en temps officiel : ${duration}.`,
    simulation_30: 'Le sujet entier en 30 minutes. Va le plus loin possible.',
    chapter_review: '30 minutes sur les questions d’un seul chapitre.',
  },
  STEP_SUBJECT: 'Choisis ton sujet',
  STEP_SOURCE: 'Choisis ta copie',
  CONTENT_SOURCES: { official: 'Sujet officiel', mixed: 'Sujet mixé' },
  CONTENT_SOURCE_HINTS: {
    official: 'Les questions du sujet officiel.',
    mixed: 'Un nouveau sujet composé exclusivement d’exercices officiels.',
  },
  OFFICIAL_PATH_FACTS: (subjects) => `${subjects} session${subjects > 1 ? 's' : ''} officielle${subjects > 1 ? 's' : ''}`,
  MIX_PATH_FACTS: (exercises, chapters) => `${exercises} exercices disponibles · ${chapters} chapitres`,
  MIX_POOL: (count) => `Sélection parmi ${count} exercices officiels`,
  MIX_CHAPTERS: (count) => `${count} chapitres représentés dans le corpus`,
  MIX_DISCLOSURE: (exercises, chapters) => `La composition maximise la couverture parmi ${exercises} exercices et ${chapters} chapitres. Les exercices exacts sont révélés à l’ouverture.`,
  SOURCE_UNAVAILABLE: 'Pas encore publié.',
  BRIEFING_STATUS_MIXED: (diploma) => `Sujet mixé · exercices officiels de ${diploma} · simulation non officielle`,
  STEP_MODE: 'Choisis ton épreuve',
  SUBJECT_YEAR: (year) => `Session ${year}`,
  CHAPTER_LABEL: 'Chapitre à réviser',
  ADVANCED: 'Options avancées',
  ATMOSPHERE: 'Ambiance',
  ATMOSPHERES: { sobre: 'Sobre', tension: 'Tension', immersif: 'Immersif' },
  ATMOSPHERE_HINTS: {
    sobre: 'Aucun effet. Le chronomètre seul.',
    tension: 'La lumière baisse avec le temps. Pouls du cadre à 5 minutes.',
    immersif: 'Salle plus sombre. Pouls du cadre dès les 10 derniers pourcents.',
  },
  TEXT_SIZE: 'Taille du texte',
  TEXT_SIZES: { normal: 'Normale', large: 'Grande' },
  MOTION: 'Animations',
  MOTIONS: { auto: 'Selon mon appareil', reduced: 'Réduites' },
  PREPARE: 'Préparer l’épreuve',

  BRIEFING_STAMP: 'SUJET · NE PAS OUVRIR AVANT LE SIGNAL',
  BRIEFING_TITLE: 'Avant d’entrer',
  BRIEFING_DURATION: 'Durée',
  BRIEFING_MODE: 'Épreuve',
  BRIEFING_CALCULATOR: 'Calculatrice',
  BRIEFING_AUTOSAVE: 'Copie',
  BRIEFING_AUTOSAVE_VALUE: 'Enregistrée automatiquement à chaque réponse.',
  BRIEFING_SCORING: 'Barème',
  BRIEFING_SCORING_VALUE: 'Note sur 20 officielle avec un barème complet. Sinon : estimation calculée seulement sur les questions corrigées automatiquement.',
  BRIEFING_STATUS: 'Statut',
  BRIEFING_STATUS_VALUE: (kind) => `${kind} · simulation non officielle`,
  BRIEFING_SOURCE: 'Source',
  BRIEFING_EXERCISES: 'Exercices du sujet',
  EXERCISE_ORIGIN: (year, duration) => `Session ${year} · environ ${duration}`,
  CANDIDATE_LABEL: 'Prénom ou pseudonyme',
  CANDIDATE_PLACEHOLDER: 'Ex. Camille',
  BRIEFING_CLOCK_NOTE: 'Le chronomètre démarre quand tu brises le sceau. Il ne s’arrête plus.',
  ENTER: 'Entrer dans l’épreuve',
  ENTERING: 'Ouverture du sujet…',
  ENTER_ERROR: 'Impossible d’ouvrir le sujet. Réessaie.',
  BACK_TO_CONFIG: '← Modifier',

  FLAP: 'NE RIEN ÉCRIRE DANS CE CADRE',
  EXERCISE: (n, total) => `Exercice ${n} / ${total}`,
  ITEM_NUMBER: (n) => `Q${n}`,
  ITEM_PART: (part, position) => `Partie ${part} · ${position}`,
  CASCADE_SEALED: 'Réponds à la question précédente pour ouvrir celle-ci.',
  /* A figure sits inside the question it serves, never between two questions. */
  FIGURE_CUE: {
    table: 'Observe le tableau ci-dessous avant de répondre.',
    line_chart: 'Observe le graphique ci-dessous avant de répondre.',
    bar_chart: 'Observe le graphique ci-dessous avant de répondre.',
    geometry: 'Observe la figure ci-dessous avant de répondre.',
    scratch: 'Observe le programme ci-dessous avant de répondre.',
    code: 'Lis le programme ci-dessous avant de répondre.',
  },
  FIGURE_BACK: {
    table: 'D’après le tableau ci-dessus.',
    line_chart: 'D’après le graphique ci-dessus.',
    bar_chart: 'D’après le graphique ci-dessus.',
    geometry: 'D’après la figure ci-dessus.',
    scratch: 'D’après le programme ci-dessus.',
    code: 'D’après le programme ci-dessus.',
  },
  FLAG: 'À revoir',
  UNFLAG: 'Ne plus revoir',
  MULTI_HINT: 'Plusieurs réponses possibles : cochez toutes les affirmations vraies.',
  NUMERIC_LABEL: 'Ta valeur',
  FRACTION_LABEL: 'Ta fraction',
  FRACTION_NUMERATOR: 'Numérateur',
  FRACTION_DENOMINATOR: 'Dénominateur',
  INTERACTION_CUE: 'Pour répondre en ligne :',
  FREE_LABEL: 'Ta réponse rédigée',
  PREVIOUS: '← Exercice précédent',
  NEXT: 'Exercice suivant →',
  REVIEW: 'Relire et sceller',
  MAP_TITLE: 'Plan de la copie',
  MAP_EXERCISE: (n) => `Ex. ${n}`,
  MAP_ITEM: (n, state) => `Question ${n}, ${state}`,
  MAP_STATES: { answered: 'répondue', empty: 'sans réponse', flagged: 'à revoir' },
  SAVE: {
    idle: 'Copie prête',
    saving: 'Enregistrement…',
    saved: 'Copie enregistrée',
    retrying: 'Hors ligne · nouvel essai',
  },
  CLOCK_LABEL: (time) => `Temps restant : ${time}`,
  CLOCK_ANNOUNCE: (time) => `Il reste ${time}.`,
  SEAL_OPEN: 'Rendre la copie',
  SEAL_TITLE: 'Rendre la copie',
  SEAL_SUMMARY: (answered, total) => `${answered} / ${total} questions répondues`,
  SEAL_UNANSWERED: 'Sans réponse',
  SEAL_FLAGGED: 'Marquées à revoir',
  SEAL_NONE: 'Aucune.',
  SEAL_WARNING: 'Une copie scellée ne peut plus être modifiée.',
  SEAL_BACK: 'Revenir à la copie',
  SEALING: 'Scellement…',
  SEAL_ERROR: 'Le scellement a échoué. Ta copie est conservée : réessaie.',
  TIME_UP: 'Temps écoulé. La copie est scellée.',
  LOCKED: 'Cette copie appartient à un autre appareil ou navigateur.',
  EXPIRED: 'Cette session a expiré.',
  RESTART: 'Recommencer ce sujet',

  REPORT_TITLE: `Rapport de simulation ${appBrandText('EXAM')}`,
  RETURNED: 'COPIE RENDUE',
  NOTE_SCALE: '/20',
  SCORE_OFFICIAL: 'Barème officiel complet',
  SCORE_ESTIMATED: 'Note estimée sur les questions corrigées automatiquement. Le barème officiel est incomplet.',
  SCORE_UNSCORED_TITLE: 'Pas de note',
  SCORE_UNSCORED: 'Trop de réponses demandent une correction humaine.',
  POINTS: (earned, possible) => `${earned} / ${possible} points`,
  AUTOMATIC_ITEMS: (earned, possible) => `${earned} / ${possible} questions justes parmi celles corrigées automatiquement`,
  COVERAGE: (percent) => `${percent} des questions corrigées automatiquement`,
  ANSWERED: (answered, total) => `Répondu ${answered} / ${total}`,
  ELAPSED: (duration) => `Durée ${duration}`,
  CANDIDATE: (name) => `Candidat : ${name}`,
  CHAPTERS_TITLE: 'Par chapitre',
  CHAPTER_SCORE: (correct, automatic) => `${correct} / ${automatic}`,
  CHAPTER_MANUAL: 'Correction humaine',
  REVISION_TITLE: 'Priorités de révision',
  REVISION_SKILL: (label, correct, automatic) => `${label} · ${correct} / ${automatic}`,
  REVISION_NONE: 'Aucune faiblesse mesurable dans les réponses corrigées automatiquement.',
  CORRECTION_TITLE: 'Correction',
  YOUR_ANSWER: 'Ta réponse',
  EXPECTED: 'Attendu',
  VERDICTS: { correct: 'Juste', wrong: 'Faux', blank: 'Sans réponse', manual: 'À faire corriger' },
  WORK_WEAK: (chapter) => `Travailler : ${chapter}`,
  REPLAY: 'Refaire une simulation',
  DOWNLOAD_PDF: 'Télécharger en PDF',
  DOWNLOAD_PDF_HINT: 'Ouvre l’impression du navigateur : choisis « Enregistrer au format PDF ».',
  HOME: 'Retour aux épreuves',
  RESULT_LOCKED: 'Ce rapport ne s’ouvre que sur l’appareil qui a passé l’épreuve.',
  RESULT_ERROR: 'Rapport introuvable ou expiré.',
  PRINT_FOOTER: `Rapport de simulation ${appBrandText('EXAM')} · simulation non officielle · ce document n’est pas un diplôme`,

  FIGURE_UNSUPPORTED: 'Figure indisponible.',
  FIGURE_CHART: (series, axis) => `Graphique : ${series} en fonction de ${axis}`,
  FIGURE_GEOMETRY: (points) => `Repère : ${points}`,
  FIGURE_TABLE: 'Tableau de données',
  FIGURE_CODE: (language) => `Programme ${language}`,
};
